'use strict';

angular.module('directives.iamEvent')

.controller('iamEventGroupSummaryController', ['$scope', 'authenticatedUserService', 'eventService', function ($scope, authenticatedUserService, eventService) {

    $scope.lastEvtsAnimPair = []
    $scope.lastEvtsAnimPair.push(_.cloneDeep($scope.model));
    $scope.lastEvtsAnimPair[0].isLastEvtActive = true;

    $scope.ctrlCtxt = {};
    $scope.eventDetails = {};

    // Get Authenticated User
    authenticatedUserService
        .getAuthenticatedUser()
        .then(function (authenticatedUser) {
            $scope.authenticatedUser = authenticatedUser;
        });

    // Get Event Details
    if ($scope.boxContext && $scope.boxContext.ShowDetails) {
        eventService
           .getEvent($scope.model.EventID)
           .then(function (eventDetails) {
               $scope.eventDetails = eventDetails;
           });
    }

    // Show Transfer More Infos
    $scope.showTransferMoreInfos = function () {
        if ($scope.model.EventTypeID === 42) return true; // EMPLOYEE/IAM/TRANSFER
        if ($scope.model.EventTypeID === 51) return true; // EMPLOYEE/IAM/TRANSFER/NOACCESSCHANGES

        return false;
    };

    // Get Summary Template Url
    $scope.getSummaryTemplateUrl = function () {

        if ($scope.model.EventTypeID === 42 || // EMPLOYEE/IAM/TRANSFER
                $scope.model.EventTypeID === 51 // EMPLOYEE/IAM/TRANSFER/NOACCESSCHANGES
            ) {
            return '/app/shared/components/directives/iamEventDirective-groupSummary_Transfer.tpl.html';
        }
      
        return '/app/shared/components/directives/iamEventDirective-groupSummary_Default.tpl.html';
    };

    // Update Last Event
    $scope.refreshEvtGroup = function (model) {

        return $scope
                .updateEventGroup()(model)
                .then(function (updatedEvtGroup) {

                    // Get Event Details
                    if (model.EventID !== updatedEvtGroup.EventID) {

                        // Creates a new controller instance
                        $scope.lastEvtsAnimPair.push(_.cloneDeep(updatedEvtGroup));

                        return eventService
                           .getEvent(updatedEvtGroup.EventID)
                           .then(function (eventDetails) {
                               $scope.eventDetails = eventDetails;
                               
                               // Activate the new event
                               if (_.size($scope.lastEvtsAnimPair) > 2) _.drop($scope.lastEvtsAnimPair, 1);
                               $scope.lastEvtsAnimPair[0].isLastEvtActive = false;
                               $scope.lastEvtsAnimPair[1].isLastEvtActive = true;

                               $scope.model = updatedEvtGroup;

                               return updatedEvtGroup;
                           });
                    } 

                    $scope.model = updatedEvtGroup;

                    return updatedEvtGroup;
                });
    };
}]);